import React from "react";

import DesktopTourIntro from "./desktop-tourIntro";
import MobileTourIntro from "./mobile-tourIntro";

const TourIntro = props => {
  const { stopIndex, tourReady, screenClass, isDesktop, windowHeight } = props;

  return isDesktop ? (
    <DesktopTourIntro
      stopIndex={stopIndex}
      screenClass={screenClass}
      tourReady={tourReady}
      isDesktop={isDesktop}
      windowHeight={windowHeight}
    />
  ) : (
    <MobileTourIntro
      stopIndex={stopIndex}
      screenClass={screenClass}
      tourReady={tourReady}
      isDesktop={isDesktop}
      windowHeight={windowHeight}
    />
  );
};

export default TourIntro;
